module.exports = __webpack_public_path__ + "img/correct-white.176065c8.svg";